// extracted by mini-css-extract-plugin
module.exports = {"error":"MobileNumber_error__pTuvo","container":"MobileNumber_container__FpskE"};